(function(){
'use strict';
var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
var $$=function(s,r){return [].slice.call((r||document).querySelectorAll(s))};
var par=[];
function initPar(root){$$('[data-parallax]',root).forEach(function(el){if(el.dataset.p)return;el.dataset.p=1;par.push(el)})}
function tick(){par.forEach(function(el){var r=el.parentNode.getBoundingClientRect();if(r.bottom<0||r.top>innerHeight)return;var p=(r.top+r.height/2-innerHeight/2)/innerHeight;el.style.transform='translate3d(0,'+(p*-6)+'%,0) scale(1.02)'})}
if(!reduce){addEventListener('scroll',function(){requestAnimationFrame(tick)},{passive:true})}
function initCount(root){
  $$('[data-count]',root).forEach(function(el){
    if(el.dataset.c)return;el.dataset.c=1;
    var end=parseFloat(el.getAttribute('data-count'))||0,dec=(String(end).split('.')[1]||'').length;
    if(reduce||!('IntersectionObserver' in window)){el.textContent=end.toFixed(dec);return}
    el.textContent=(0).toFixed(dec);
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(!e.isIntersecting)return;io.disconnect();var t0=performance.now(),d=1600;(function f(now){var k=Math.min(1,(now-t0)/d);k=1-Math.pow(1-k,4);el.textContent=(end*k).toFixed(dec);if(k<1)requestAnimationFrame(f)})(t0)})},{threshold:.4});
    io.observe(el);
  });
}
function initAnatomy(root){
  $$('[data-anatomy]',root).forEach(function(a){
    if(a.dataset.a)return;a.dataset.a=1;
    var spots=$$('.spot',a),items=$$('.parts li',a);
    function on(i){spots.forEach(function(s,j){s.setAttribute('aria-pressed',j===i?'true':'false')});items.forEach(function(li,j){li.classList.toggle('on',j===i);var b=li.querySelector('button');if(b)b.setAttribute('aria-expanded',j===i?'true':'false')})}
    spots.forEach(function(s,i){s.addEventListener('click',function(){on(i)})});
    items.forEach(function(li,i){var b=li.querySelector('button');if(b)b.addEventListener('click',function(){on(i)})});
    if(items.length)on(0);
  });
}
function init(root){initPar(root);initCount(root);initAnatomy(root);tick()}
init(document);
document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();